const Footer = () => {
    return (
        <footer>
            <p>Website not affiliated with the Chunky project.<br/><i>༼ つ ◕_◕ ༽つ v0.42~</i></p>
        </footer>
    );
}

export default Footer;